import { useTranslation } from '@wix/yoshi-flow-editor';
import React from 'react';
import { Spinner, Text } from '@wix/wix-ui-tpa/cssVars';
import { st as loadingSt, classes } from './LoadingWrapper.st.css';
import useObservable from '../../../Shared/Hooks/useObservable.Hook';
import { getAppSettings } from '../../Services/AppSettings.service';

const LoadingWrapper = () => {
  const { t } = useTranslation();
  const [, appSettings]: any = useObservable(getAppSettings());
  const isMobile = appSettings !== undefined ? appSettings?.isMobile : '';
  const isMembersArea = appSettings?.isMembersArea ?? false;
  const text = t('app.widget.spinner.text');

  return (
    <>
      <div
        className={
          classes.loadingContainer +
          ' ' +
          (isMobile ? classes.mobileContainer : '')
        }
      >
        <div>
          <Spinner className={classes.spinnerWrapper} diameter={50} />
        </div>
        <div>
          <Text
            className={loadingSt(classes.loadingText, {
              isMobile,
              isMembersArea,
            })}
          >
            {' '}
            {text}
          </Text>
        </div>
      </div>
    </>
  );
};

export default LoadingWrapper;
